import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { UploadFile } from 'antd'
import { Moment } from 'moment'
import { Color } from '../theme'

export type GenerationTypeKey = 'WIND' | 'SOLAR' | 'DIESEL' | 'OTHER'
export type IGenerationType = {
  label: string
  value: GenerationTypeKey
  icon: IconProp
  color: Color
}
export const GENERATION_TYPES: Record<GenerationTypeKey, IGenerationType> = {
  WIND: { label: 'Wind', value: 'WIND', icon: 'wind', color: 'blue' },
  SOLAR: { label: 'Solar', value: 'SOLAR', icon: 'sun', color: 'yellow' },
  DIESEL: { label: 'Diesel', value: 'DIESEL', icon: 'gas-pump', color: 'volcano' },
  OTHER: { label: 'Other', value: 'OTHER', icon: 'question', color: 'dark' },
}

export type IPlantForm = {
  name?: string
  generationType: GenerationTypeKey
  installedPowerKw: number
  licensedPowerKw: number
  feedInTariffDollars: number
  feedInTariffDollarsEndDate: Moment | null
  generationFile: [UploadFile]
}
export type IPlant = {
  id: string
  name: string
  createdAt: string
  createdBy: string
  accessibility: string
  generationType: GenerationTypeKey
  installedPowerKw: number
  licensedPowerKw: number
  feedInTariffDollars: number
  feedInTariffDollarsEndDate: string
  url: string
  logs: string
}

export type IPlantPost = {
  name: string
  generationType: string
  installedPowerKw: number
  licensedPowerKw: number
  feedInTariffDollars: number
  feedInTariffDollarsEndDate: string | null
  url: string
}
export type IPlantEdit = Omit<IPlantPost, 'name'>
